import {
  CreateBeneficiaryModal,
  InfoContainer,
  ContentContainer,
  ButtonsContainer,
  ConfirmButton,
  CloseButton,
  MainInfo
} from './CreateBeneficiary.styles';
import { useState, useEffect } from 'react';
import states from 'src/constants/states';
import countries from 'src/constants/countries';

export default function CreateBeneficiary({
  showModal,
  onClose,
  onConfirm,
  beneficiaryData,
  setBeneficiaryData,
  totalAssignedPercentage
}) {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBeneficiaryData({
      ...beneficiaryData,
      [name]: name === 'percentage' ? parseFloat(value) : value
    });
  };

  return (
    <CreateBeneficiaryModal showModalCreateBeneficiary={showModal}>
      <ContentContainer>
        <h2>
          Datos del <span>beneficiario</span>
        </h2>
        <InfoContainer>
          <MainInfo>
            <div>
              <h3>Nombre(s):</h3>
              <input
                value={beneficiaryData.firstName}
                onChange={handleInputChange}
                name="firstName"
              />
            </div>
            <div>
              <h3>Apellido Paterno:</h3>
              <input
                value={beneficiaryData.lastNameM}
                onChange={handleInputChange}
                name="lastNameM"
              />
            </div>
            <div>
              <h3>Apellido Materno:</h3>
              <input
                value={beneficiaryData.lastNameP}
                onChange={handleInputChange}
                name="lastNameP"
              />
            </div>
            <div>
              <h3>Relación o parentesco:</h3>
              <select
                value={beneficiaryData.relationship}
                onChange={handleInputChange}
                name="relationship"
              >
                <option value={undefined}>Seleccionar...</option>
                <option value="padre">Padre</option>
                <option value="madre">Madre</option>
                <option value="hijo-a">Hijo (a)</option>
                <option value="esposo-a">Esposo (a)</option>
                <option value="hermano-a">Hermano (a)</option>
              </select>
            </div>
            <div>
              <h3>Porcentaje:</h3>
              <select
                value={beneficiaryData.percentage}
                onChange={handleInputChange}
                name="percentage"
              >
                <option value={0}>Seleccionar...</option>
                <option value={0.1}>10%</option>
                <option value={0.2}>20%</option>
                <option value={0.25}>25%</option>
                <option value={0.3}>30%</option>
                <option value={0.4}>40%</option>
                <option value={0.5}>50%</option>
                <option value={0.6}>60%</option>
                <option value={0.7}>70%</option>
                <option value={0.8}>80%</option>
                <option value={0.9}>90%</option>
                <option value={1}>100%</option>
              </select>
            </div>
          </MainInfo>
          <MainInfo>
            <div>
              <h3>Calle:</h3>
              <input value={beneficiaryData.street} onChange={handleInputChange} name="street" />
            </div>
            <div>
              <h3>Número externo:</h3>
              <input value={beneficiaryData.numExt} onChange={handleInputChange} name="numExt" />
            </div>
            <div>
              <h3>Número interno:</h3>
              <input value={beneficiaryData.numInt} onChange={handleInputChange} name="numInt" />
            </div>
            <div>
              <h3>País:</h3>
              <select name="country" onChange={handleInputChange} value={beneficiaryData.country}>
                {countries.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <h3>Estado:</h3>
              <select name="state" onChange={handleInputChange} value={beneficiaryData.state}>
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <h3>Municipio o Alcaldía:</h3>
              <input
                value={beneficiaryData.district}
                onChange={handleInputChange}
                name="district"
              />
            </div>
            <div>
              <h3>Código Postal:</h3>
              <input
                value={beneficiaryData.postalCode}
                onChange={handleInputChange}
                name="postalCode"
              />
            </div>
          </MainInfo>
        </InfoContainer>
        <ButtonsContainer>
          <CloseButton onClick={onClose}>Cancelar</CloseButton>
          <ConfirmButton onClick={onConfirm}>Crear</ConfirmButton>
        </ButtonsContainer>
      </ContentContainer>
    </CreateBeneficiaryModal>
  );
}
